export default "__VITE_ASSET__dc0dfa99__"